import { number, object, string } from "yup";
import i18n from "../../../../locales/i18n";
import { password_regex } from "../../../../utils/regex";

export const validationSchema = object({
  oldPassword: string().required(
    i18n.t("resources.changePassword.valid.enter_old_password")
  ),
  password: string()
    .required(i18n.t("resources.changePassword.valid.enter_password"))
    .min(
      8,
      ({ min }) =>
        `${i18n.t("resources.changePassword.password")} ${min} ${i18n.t(
          "resources.changePassword.valid.invalid_lenght"
        )}`
    )
    .test(
      i18n.t("resources.changePassword.valid.password"),
      i18n.t("resources.changePassword.valid.password"),
      function () {
        return password_regex.test(this.parent.password);
      }
    ),
  passwordCompare: string()
    .required(i18n.t("resources.changePassword.valid.enter_password"))
    .test(function (value, { createError, path }) {
      if (this.parent.password !== this.parent.passwordCompare)
        return createError({
          message: i18n.t("resources.changePassword.valid.equal_password"),
          path: path,
        });

      return true;
    }),
  // ChangePasswordPeriod: number().required(
  //   i18n.t("resources.changePassword.valid.enter_period")
  // ),
});
